import { render, staticRenderFns } from "./ResultNegative.vue?vue&type=template&id=5035b660&scoped=true&"
import script from "./ResultNegative.vue?vue&type=script&lang=js&"
export * from "./ResultNegative.vue?vue&type=script&lang=js&"
import style0 from "./ResultNegative.vue?vue&type=style&index=0&id=5035b660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5035b660",
  null
  
)

export default component.exports